<template>
  <section class="breadcrumb">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ name: 'spaces'}">Accueil</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'editor-entities', params: { spaceId: space.spaceId }}" v-if="space">Espace : {{ space.name }}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'editor-contents', params: { spaceId: space.spaceId, entityId: this.entity.entityId }}" v-if="entity">
        Contenu : {{ entity.name }}
      </el-breadcrumb-item>
      <el-breadcrumb-item  v-if="content">
       {{ content.document[entity.displayField] }}
      </el-breadcrumb-item>
      <el-breadcrumb-item  v-if="$route.name === 'editor-media'">
        Media
      </el-breadcrumb-item>
    </el-breadcrumb>
  </section>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'breadcrumb',
  components: {
  },
  data() {
    return {
      space: null,
      entity: null,
      content: null,
    };
  },
  async created() {
    await this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    async fetchData() {
      this.space = null;
      this.entity = null;
      this.content = null;

      if (this.$route.params.spaceId) {
        this.space = await api.getSpace(this.$route.params.spaceId);

        if (this.$route.params.entityId) {
          this.entity = await api.getEntity(
            this.$route.params.spaceId,
            this.$route.params.entityId,
          );
            if (this.$route.params.contentId && this.$route.params.versionId) {
              this.content = await api.getVersion(
                this.$route.params.spaceId,
                this.$route.params.entityId,
                this.$route.params.contentId,
                this.$route.params.versionId,
              );
            }
        }
      }
    },
  },
};
</script>

<style lang="sass">
.breadcrumb
  position: fixed
  top: 0
  left: 200px
  right: 0
  padding: 1rem 2rem
  background: white
  z-index: 2000
  .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover
    color: #001861
    font-weight: bold
</style>
